import React from 'react'
import MainNavigation from '../components/Navigation'

export default function Chats() {
  return (
    <div>
      <MainNavigation />
      <div>
        Chats
      </div>
    </div>
  )
}
